import { render, staticRenderFns } from "./lookup-page.vue?vue&type=template&id=3bd1f3c4&scoped=true"
import script from "./lookup-page.vue?vue&type=script&lang=js"
export * from "./lookup-page.vue?vue&type=script&lang=js"
import style0 from "./lookup-page.vue?vue&type=style&index=0&id=3bd1f3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd1f3c4",
  null
  
)

export default component.exports